import { render, staticRenderFns } from "./Occurrences.vue?vue&type=template&id=6fd3e906&scoped=true&"
import script from "./Occurrences.vue?vue&type=script&lang=js&"
export * from "./Occurrences.vue?vue&type=script&lang=js&"
import style0 from "./Occurrences.vue?vue&type=style&index=0&id=6fd3e906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd3e906",
  null
  
)

export default component.exports